<script>
import PageHeader from "@/components/page-header.vue";
import add from "@/views/pages/Dilfoods/items/add.vue";
import Layout from "@/views/layouts/main.vue";
import { ItemPath, MenuPath } from "@/path";
import axios from "axios";
import Image_list from "@/views/pages/Dilfoods/items/image_list.vue";
import Gravy_packaging_list from "@/views/pages/Dilfoods/items/gravy_packaging_list";
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch";
import Brands from "./brands.vue";
import EditIcon from "@/views/pages/Dilfoods/Common/icons/EditIcon.vue";
import DeleteIcon from "@/views/pages/Dilfoods/Common/icons/DeleteIcon.vue";
import UploadIcon from "@/views/pages/Dilfoods/Common/icons/UploadIcon.vue";
import ListIcon from "@/views/pages/Dilfoods/Common/icons/ListIcon.vue";
import CopyIcon from "@/views/pages/Dilfoods/Common/icons/CopyIcon.vue";
import Swal from "sweetalert2";

export default {
  components: {
    SelectWithSearch,
    Gravy_packaging_list,
    Layout,
    add,
    PageHeader,
    "image-list": Image_list,
    Brands,
    EditIcon,
    DeleteIcon,
    UploadIcon,
    ListIcon,
    CopyIcon
  },
  data() {
    return {
      title: "Items",
      headerItems: [
        {
          text: "List",
        },
        {
          text: "Item",
          active: true,
        },
      ],
      selectedItem: null,
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      items: [],
      fields: [
        { key: "title", sortable: true },
        { key: "packaging_items", sortable: true },
        { key: "gravy_items", sortable: true },
        "brands",
        "images",
        "actions",
      ],
      key: 0,
      filter: [],
      selectedImages: [],
      current_page: 1,
      search: "",
      show_list: null,
      menu: null,
      sortBy: "",
      sortDesc: false,
    };
  },
  watch: {
    current_page() {
      this.getitems();
    },
    search() {
      this.getitems();
    },
    menu() {
      this.getitems();
    },
  },
  computed: {
    MenuPath() {
      return MenuPath;
    },
  },
  mounted() {
    this.getitems();
  },
  methods: {
    reload() {
      this.selectedItem = null;
      this.getitems();
    },
    setEdit(v) {
      this.addItem();
      this.selectedItem = v;
      this.key += 1;
    },
    addItem() {
      this.selectedItem = null;
      this.$bvModal.show("bv-add-item");
    },
    uploadToUP(v) {
      this.selectedItem = v;
      this.key += 1;
      this.$bvModal.show("bv-upload-item");
    },
    async deleteData(v) {
      try {
        let res = await axios.delete(this.base_url + ItemPath.ALL + "/" + v.id);
        if (res.data.status) {
          this.reload();
        }
      } catch (e) {
        console.log(e);
      }
    },
    showImages(data) {
      this.selectedItem = data;
      this.$bvModal.show("bv-images-list");
    },
    openSampleList(v) {
      console.log(v);
      this.show_list = v.packaging_items.map((v) => {
        return {
          name: v.packaging.name,
          value: "qty - " + v.qty + " brand - " + v.brand?.name,
        };
      });
      this.$bvModal.show("bv-packaging-gravy-list");
    },
    openGravyList(v) {
      console.log(v);
      this.show_list = v.gravy_items.map((v) => {
        return {
          name: v.gravy.name,
          value: "qty - " + v.qty + " brand - " + v.brand?.name,
        };
      });
      this.$bvModal.show("bv-packaging-gravy-list");
    },
    async duplicateItem(v){
      try {
        let res = await axios.post(this.base_url + ItemPath.DUPLICATE_ITEM,{
          id : v.id
        });
        if(res.data.status){
          Swal.fire("Success","","success");
          window.location.reload();
        }
      } catch (error) {
        console.log(error);
      }
    },
    showBrands(v) {
      console.log(v, "kksfafs");
      this.selectedItem = v;
      this.$bvModal.show("bv-brand-tagging");
    },
    async getitems(v) {
      console.log(v);
      if (v && v.sortBy && v.sortBy == "packaging_items") {
        this.sortBy = "packaging_items";
        this.sortDesc = v.sortDesc;
      }
      if (v && v.sortBy && v.sortBy == "gravy_items") {
        this.sortBy = "gravy_items";
        this.sortDesc = v.sortDesc;
      }
      if (v && v.sortBy && v.sortBy == "title") {
        this.sortBy = "title";
        this.sortDesc = v.sortDesc;
      }
      try {
        let res = await axios.get(this.base_url + ItemPath.ALL, {
          params: {
            search: this.search,
            page: this.current_page,
            sortBy: this.sortBy,
            sortDesc: this.sortDesc,
            menu: this.menu,
          },
        });
        if (res.data.status) {
          this.items = res.data.data;
          this.key += 1;
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-6">
                <b-button @click="addItem()" class="btn btn-primary mb-10 pb-10"
                  >Add items</b-button
                >
                <b-card-body>
                  <b-form-group>
                    <label>Menu</label>
                    <select-with-search
                      :search_api="MenuPath.MENU_SEARCH"
                      track_by="id"
                      display="name"
                      @selectedOption="(v) => (menu = v)"
                    ></select-with-search>
                  </b-form-group>
                </b-card-body>
                <b-modal
                  id="bv-add-item"
                  size="xl"
                  :title="
                    selectedItem && Object.keys(selectedItem).length > 0
                      ? '' + this.selectedItem.title + ''
                      : 'Add item'
                  "
                  hide-footer
                >
                  <add
                    @update="reload()"
                    :key="key"
                    :selected_item="selectedItem"
                  ></add>
                </b-modal>
                <b-modal
                  id="bv-upload-item"
                  title="Upload to urban piper"
                  hide-footer
                >
                </b-modal>
                <b-modal
                  id="bv-packaging-gravy-list"
                  :title="
                    selectedItem && Object.keys(selectedItem).length > 0
                      ? '' + this.selectedItem.title + ''
                      : ''
                  "
                >
                  <Gravy_packaging_list
                    :data="show_list"
                  ></Gravy_packaging_list>
                </b-modal>
                <b-modal
                  id="bv-images-list"
                  size="sm"
                  :title="
                    selectedItem && Object.keys(selectedItem).length > 0
                      ? '' + this.selectedItem.title + ''
                      : ''
                  "
                >
                  <image-list :data="selectedItem"></image-list>
                </b-modal>
                <b-modal
                  id="bv-brand-tagging"
                  size="xl"
                  :title="
                    selectedItem && Object.keys(selectedItem).length > 0
                      ? '' + this.selectedItem.title + ''
                      : ''
                  "
                  hide-footer
                >
                  <Brands :data="selectedItem"></Brands>
                </b-modal>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <div class="pb-2 float-right w-25">
                <b-row>
                  <b-col sm="12">
                    <b-input-group size="sm">
                      <b-input-group-prepend is-text>
                        <i class="fa fa-search"></i>
                      </b-input-group-prepend>
                      <b-input
                        size="sm"
                        debounce="300"
                        placeholder="Search"
                        v-model="search"
                      ></b-input>
                    </b-input-group>
                  </b-col>
                </b-row>
              </div>
              <b-table
                :key="items.key"
                :items="items.data"
                :fields="fields"
                responsive="sm"
                :filter="filter"
                :current-page="current_page"
                @sort-changed="getitems"
              >
                <template v-slot:cell(images)="row">
                  <div style="display: flex; gap: 0px">
                    <div @click="showImages(row.item)">
                      <ListIcon variant="gray" />
                    </div>
                  </div>
                </template>
                <template v-slot:cell(packaging_items)="row">
                  <div class="d-flex">
                    <p class="ml-4">
                      <i
                        v-if="row.item.packaging_items_count > 0"
                        style="color: green"
                        class="fa fa-check-circle"
                      ></i>
                      <i
                        v-else
                        class="fa fa-exclamation-circle"
                        style="color: #8a8a71"
                      ></i>
                    </p>
                    <!-- <b-button class="ml-2" @click="openSampleList(row.item)" size="sm"><i class="fa fa-list-alt"></i></b-button> -->
                  </div>
                </template>
                <template v-slot:cell(gravy_items)="row">
                  <div class="d-flex">
                    <p class="ml-4">
                      <i
                        v-if="row.item.gravy_items_count > 0"
                        style="color: green"
                        class="fa fa-check-circle"
                      ></i>
                      <i
                        v-else
                        class="fa fa-exclamation-circle"
                        style="color: #8a8a71"
                      ></i>
                    </p>
                    <!-- <b-button class="ml-2" @click="openGravyList(row.item)" size="sm"><i class="fa fa-list-alt"></i></b-button> -->
                  </div>
                </template>
                <template v-slot:cell(brands)="row">
                  <div style="display: flex; gap: 0px">
                    <div @click="showBrands(row.item)">
                      <ListIcon variant="primary" />
                    </div>
                  </div>
                </template>
                <template v-slot:cell(actions)="row">
                  <div style="display: flex; gap: 0px">
                    <div @click="uploadToUP(row.item)">
                      <UploadIcon :title="'Update to urban piper'" />
                    </div>
                    <div @click="duplicateItem(row.item)">
                      <CopyIcon :title="'Duplicate'" />
                    </div>
                    <div @click="setEdit(row.item)">
                      <EditIcon />
                    </div>
                    <div @click="deleteData(row.item)">
                      <DeleteIcon />
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      :key="items.key"
                      v-model="current_page"
                      :total-rows="items.total"
                      :per-page="items.per_page"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped></style>
